module.exports = __webpack_public_path__ + "src/images/products/trendsetter/109_Surf Is Love T-Shirt.png";